import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TEMPLATES_QUERY_KEY} from "../queryKeys";
import {ReachTemplate} from "./types";

export type UpdateTranslationPayload = {
  subject: string | null;
  pre_header: string | null;
  body: string;
  landing_page_body: string | null;
  channel_message_code: string | null;
};

type Variables = {id: string; payload: UpdateTranslationPayload};

const updateTranslation = async ({id, payload}: Variables): Promise<ReachTemplate> => {
  const response = await axiosReachInstance.patch<ReachTemplate, AxiosResponse<ReachTemplate>, UpdateTranslationPayload>(
    `/templates/${id}/translation`,
    payload
  );
  return response.data;
};

export const useUpdateTranslation = (
  options?: BaseMutationOptions<ReachTemplate, Variables>
): BaseUseMutationResult<ReachTemplate, Variables> => {
  return useBaseMutation<ReachTemplate, Variables>(updateTranslation, {
    ...options,
    prefixKeysToReset: () => [[TEMPLATES_QUERY_KEY]],
  });
};
